// import Vue from 'vue';
import _axios from "./api";
const $cookie = require("vue-cookie");
import * as tool from "./tool";

export default function U(callback) {
  /**
   * todo 代理商模式 1   管理员模式 2
   */

  if (window.location.hash.toLowerCase().includes("signout=1")) {
    $cookie.set("sessionId", null, {
      domain: window.__domain__,
      path: "/",
      expires: "-1"
    });
    $cookie.set("userId", null, {
      domain: window.__domain__,
      path: "/",
      expires: "-1"
    });
    $cookie.set("fullName", null, {
      domain: window.__domain__,
      path: "/",
      expires: "-1"
    });
    $cookie.set("faceImg", null, {
      domain: window.__domain__,
      path: "/",
      expires: "-1"
    });
  }

  /**
   * todo 检测 是 代理商 还是 管理员 ，  进行不同的登录验证
   */

  let userId, sessionId;
  let roleStatus = tool.session.get("role") || {};
  if (roleStatus.roleFlag) {
    let user = tool.session.get("user") || {};
    //~ 管理员
    _axios("ManagerUsers.isLoginVerification", {
      userExtend: user
    }).then(
      res => {
        tool.session.set("user", res.user);
        tool.session.set("role", { roleFlag: true, roleId: "1" });

        hvuex({ user: res, role: { roleFlag: false, roleId: "1" } });

        return callback(res.user, roleStatus);
      },
      err => {
        tool.clearAllCookie();
        return callback(err);
      }
    );
  } else {
    //~ 代理商
    userId = $cookie.get("userId");
    sessionId = $cookie.get("sessionId");
    if (userId && sessionId && userId != null && sessionId != null) {
      loginTrue();
    } else {
      loginFalse();
    }
  }

  function loginTrue() {
    _axios("client.usersByUserIdSectionId", {
      userId,
      sectionId: null,
      obj: {
        userId,
        sectionI: null,
        sessionID: sessionId
      }
    }).then(r => {
      if (r.sessionID && r.sessionID != "") {
        $cookie.set("sessionId", r.sessionID, {
          domain: window.__domain__,
          path: "/",
          expires: "2h"
        });
        $cookie.set("userId", r.userId, {
          domain: window.__domain__,
          path: "/",
          expires: "2h"
        });
        $cookie.set("fullName", r.fullName, {
          domain: window.__domain__,
          path: "/",
          expires: "2h"
        });
        $cookie.set("faceImg", r.faceImg, {
          domain: window.__domain__,
          path: "/",
          expires: "2h"
        });

        _axios("client.usersByIds", {
          userId: [r.userId],
          userExtend: r
        }).then(res => {
          let flag = res[0].agentFlag;
          if ([1, 2, 3, 4, 5, 6, 7, 8].includes(flag)) {
            if (!res[0].mPhone && !window.location.href.includes("localhost")) {
              window.alert("请绑定手机号之后再操作！");
              // window.location.href = `https://www.pingcexue.com/UserManage/UserCenter.aspx?flag=0`;
              window.location.href = `https://www${window.__domain__}/UserManage/UserCenter.aspx?flag=0`;
            }

            tool.session.set("user", r);
            tool.session.set("role", { roleFlag: false, roleId: "0" });

            hvuex({ user: r, role: { roleFlag: false, roleId: "0" } });

            return callback(r, roleStatus);
          } else {
            // tool.clearAllCookie();
            // return callback(false);
            return callback(r, roleStatus, r.roleId == 1 ? "student" : "");
          }
        });
      } else {
        $cookie.set("sessionId", null, {
          domain: window.__domain__,
          path: "/",
          expires: "-1"
        });
        $cookie.set("userId", null, {
          domain: window.__domain__,
          path: "/",
          expires: "-1"
        });
        $cookie.set("fullName", null, {
          domain: window.__domain__,
          path: "/",
          expires: "-1"
        });
        $cookie.set("faceImg", null, {
          domain: window.__domain__,
          path: "/",
          expires: "-1"
        });
        return callback(false);
      }
    });
  }

  function loginFalse() {
    return callback(false);
  }
}



// WEBPACK FOOTER //
// ./src/utils/simpleUser.js